export const SUBSCRIPTION_TIERS = {
  REGULAR: 1,
  GOLD: 2,
  PLATINUM: 3
}

export const SLOTS_BY_TIER = {
  [SUBSCRIPTION_TIERS.REGULAR]: 3,
  [SUBSCRIPTION_TIERS.GOLD]: 6,
  [SUBSCRIPTION_TIERS.PLATINUM]: 9
}

export const TIER_LABELS = {
  [SUBSCRIPTION_TIERS.REGULAR]: 'Regular',
  [SUBSCRIPTION_TIERS.GOLD]: 'Gold',
  [SUBSCRIPTION_TIERS.PLATINUM]: 'Platinum'
}

export const REPEAT_TYPES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  CUSTOM: 'custom'
}

export const YOUR_NEWS_GUIDELINES = [
  {
    title: 'NEWS',
    paragraphs: ['News is essential in everyday life because it keeps people informed about events happening around the world.\nIt helps individuals make better decisions by understanding current issues, trends, and developments.']
  },
  {
    title: 'YOUR NEWS',
    paragraphs: ['Your News delivers updates exactly the way you need them. Get information tailored to your interests and preferences.\nReceive news on the topics and industries that matter most to you.Choose the days and times that suit your schedule.\nStay informed effortlessly with news designed around you.']
  },
  {
    title: 'HOW TO USE',
    paragraphs: ['Gold and Platinum users enjoy full control over their News experience.\nEasily edit the News tab to personalize the type of news you want\nSet your preferred alert times and choose the days you want updates\nStay informed with news tailored exactly to your interests.\nsmarter, more flexible way to get the news that matters to you.']
  },
  {
    title: 'SOURCE',
    paragraphs: ['All News Source Through Open AI and AI can make mistakes. Please double-check responses']
  }
]

export const YOUR_NEWS_SUBSCRIPTION_TYPES = [
  {
    subscription_code: 'R',
    subscription_name: 'Regular',
    subscription_colors: ['#50b3f6', '#8DD5F4', '#50b3f6']
  },
  {
    subscription_code: 'G',
    subscription_name: 'Gold',
    subscription_colors: ['#a48011', '#e7cd77', '#a48011']
  },
  {
    subscription_code: 'P',
    subscription_name: 'Platinum',
    subscription_colors: ['#8A8A8A', '#D4D4D4', '#8A8A8A']
  }
]

export const ABOUT_US_ICON_URL = 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Dev-AboutCoffeeWeb.png'
